import React from 'react'
import classnames from 'classnames'
import { TextVariant } from '@lounge-fe/ui-kit/src/components/Text/types'
import { Image, Notification, Text } from '@lounge-fe/ui-kit'
import ProductQuickAddBlock from '../ProductQuickAddBlock'
import {
  BlockSettings,
  ProductQuickAddSettings,
  TextBlockProps,
  HeadingProps,
  ImageBlockProps,
  NotificationBlockProps,
} from './types'
import { CollectionProducts } from '../ModalGroup/CollectionProducts'
import { Button } from '../ModalGroup/Button'

export const defaultBlockRegistry: {
  [K in keyof BlockSettings]: React.ComponentType<BlockSettings[K]>
} = {
  collection_products: CollectionProducts,
  button: Button,
  spacer: ({ spacer }: { spacer: string }) => <div className={spacer} />,
  text: ({
    text,
    tag = 'p',
    text_size: variant,
    margin_bottom: marginBottom = 'mb-0',
  }: TextBlockProps) => (
    <Text
      as={tag}
      variant={variant as TextVariant}
      dangerouslySetInnerHTML={{ __html: text }}
      className={classnames(marginBottom)}
    />
  ),
  heading: ({ heading, heading_size: variant, is_h1 }: HeadingProps) => (
    <Text
      as={is_h1 ? 'h1' : 'h2'}
      variant={variant as TextVariant}
      dangerouslySetInnerHTML={{ __html: heading }}
    />
  ),
  html: ({ html }: { html: string }) => (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  ),
  product_quick_add: (props: ProductQuickAddSettings) => (
    <ProductQuickAddBlock data={props} />
  ),
  image: ({ image, width, height, alignment }: ImageBlockProps) => (
    <div className={classnames('flex', alignment)}>
      <Image
        data={{
          src: image,
          width,
          height,
          crop: 'center',
        }}
        width={width}
        height={height}
        loading="lazy"
      />
    </div>
  ),
  notification: ({ notification_text }: NotificationBlockProps) => (
    <Notification severity="default">
      <span dangerouslySetInnerHTML={{ __html: notification_text }} />
    </Notification>
  ),
}

export type DefaultBlockRegistry = typeof defaultBlockRegistry
